import { render, staticRenderFns } from "./TableWithSearch.vue?vue&type=template&id=9b97ae84&"
import script from "./TableWithSearch.vue?vue&type=script&lang=ts&"
export * from "./TableWithSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports